var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconThin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 14 14 14 14 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Business-details",
    transform: "translate(-345.000000, -32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy-20",
    transform: "translate(345.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09977778,7 L13.7713333,1.32844444 C14.0762222,1.02355556 14.0762222,0.532 13.7713333,0.227111111 C13.468,-0.0762222222 12.9764444,-0.0762222222 12.6715556,0.227111111 L7,5.90022222 L1.32688889,0.227111111 C1.02355556,-0.0762222222 0.532,-0.0762222222 0.227111111,0.227111111 C-0.0762222222,0.532 -0.0762222222,1.02355556 0.227111111,1.32844444 L5.90022222,7 L0.227111111,12.6715556 C-0.0762222222,12.9764444 -0.0762222222,13.468 0.227111111,13.7728889 C0.379555556,13.9237778 0.578666667,14 0.777777778,14 C0.976888889,14 1.176,13.9237778 1.32688889,13.7728889 L7,8.09977778 L12.6715556,13.7728889 C12.824,13.9237778 13.0231111,14 13.2222222,14 C13.4213333,14 13.6204444,13.9237778 13.7713333,13.7728889 C14.0762222,13.468 14.0762222,12.9764444 13.7713333,12.6715556 L8.09977778,7 Z",
    id: "Fill-1",
    fill: "currentColor",
    mask: "url(#mask-2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconThin);
export default __webpack_public_path__ + "static/media/CloseIconThin.a177f86ae80f25021968c65f9328fc70.svg";
export { ForwardRef as ReactComponent };